export default __webpack_public_path__ + "static/media/FiraSans-Italic.e8fb1d84.woff";